<template>
  <form @submit.prevent="submit">
    <h3>{{ $t('twoFactorVerification') }}</h3>
    <p class="mb-1">{{ $t('runMobileAuthenticator') }}:</p>
    <WCFormGroup>
      <label for="two-factor-form__verification-code">{{ $t('verificationCode') }}</label>
      <WCInput
        id="two-factor-form__verification-code"
        v-model="form.code"
        :state="$v.form.code.$error ? 'invalid' : null"
        @input="$v.form.code.$touch()"
      />
    </WCFormGroup>
    <button type="submit" class="btn btn-primary btn-block" :disabled="$v.form.$invalid">
      {{ $t('submit') }}
    </button>
    <button class="btn btn-outline-dark btn-block two-factor-form__btn-cancel" @click="cancel">
      {{ $t('cancel') }}
    </button>
    <hr />
    <p class="text-center">
      {{ $t('phoneOrAppMissing') }}
      <button
        class="btn btn-link underline-link-from-center p-0 m-0 two-factor-form__btn-email"
        @click="email"
      >
        {{ $t('getCodeViaEmail') }}
      </button>
    </p>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';

export default {
  name: 'WCTwoFactorForm',
  components: {
    WCFormGroup,
    WCInput,
  },
  data() {
    return {
      form: {
        code: '',
      },
    };
  },
  methods: {
    submit() {
      this.$emit('submit', this.form);
    },
    email() {
      this.$emit('email');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
  validations: {
    form: {
      code: {
        required,
      },
    },
  },
};
</script>

<style scoped lang="scss"></style>
